import Slide1 from '../img/slide-1.png'
import Slide11 from '../img/slide-1-mobile.png'
import Slide2 from '../img/slide-2.png';
import Slide22 from '../img/slide-2-mobile.png';
import Slide3 from '../img/slide-3.jpg';
import Slide4 from '../img/slide-video.png';
import Slide44 from '../img/slide-video-mobile.png';
import Slide5 from '../img/slide-social.png';
import Slide55 from '../img/slide-social-mobile.png';


const SlideShow = () => {
return(
<div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">

  <div class="carousel-inner">
  
   <div class="carousel-item active" data-bs-interval="3000">
      <img src={Slide1} class="d-none d-md-block w-100" alt=""></img>
      <img src={Slide11} class="d-block d-md-none w-100" alt=""></img>
      <div class="carousel-caption d-flex align-items-center justify-content-center">
    <div class="d-none d-sm-block">
    <h2 style={{'fontWeight': 'bold'}}>GRAPHIC DESIGNER</h2>
    <p class="m-0" style={{'fontSize': '20px'}}>Realizzazione grafica offline ed online</p>
    </div>
    <div class="d-block d-sm-none">
    <h3 style={{'fontWeight': 'bold'}}>GRAPHIC DESIGNER</h3>
    <p class="m-0" style={{'fontSize': '15px'}}>Realizzazione grafica <br></br> offline ed online</p>
    </div>
    </div>
    </div>

   <div class="carousel-item" data-bs-interval="3000">
      <img src={Slide2} class="d-none d-md-block w-100" alt=""></img>
      <img src={Slide22} class="d-block d-md-none w-100" alt=""></img>
      <div class="carousel-caption d-flex align-items-center justify-content-center">
    <div class="d-none d-sm-block">
    <h2 style={{'fontWeight': 'bold'}}>WEB DESIGNER - DEVELOPER</h2>
    <p class="m-0" style={{'fontSize': '20px'}}>Ideazione grafica e sviluppo siti e app</p>
    </div>
    <div class="d-block d-sm-none">
    <h3 style={{'fontWeight': 'bold'}}>WEB DESIGNER<br></br>DEVELOPER</h3>
    <p class="m-0" style={{'fontSize': '15px'}}>Ideazione grafica<br></br>e sviluppo siti e app</p>
    </div>
    </div>
    </div>

   <div class="carousel-item" data-bs-interval="3000">
      <img src={Slide5} class="d-none d-md-block w-100" alt=""></img>
      <img src={Slide55} class="d-block d-md-none w-100" alt=""></img>
      <div class="carousel-caption d-flex align-items-center justify-content-center">
    <div class="d-none d-sm-block">
    <h2 style={{'fontWeight': 'bold'}}>SOCIAL CONTENT CREATOR</h2>
    <p class="m-0" style={{'fontSize': '20px'}}>Creazione contenuti per social</p>
    </div>
    <div class="d-block d-sm-none">
    <h3 style={{'fontWeight': 'bold'}}>SOCIAL <br></br>CONTENT CREATOR</h3>
    <p class="m-0" style={{'fontSize': '15px'}}>Creazione contenuti per social</p>
    </div>
    </div>
    </div>


   <div class="carousel-item" data-bs-interval="3000">
      <img src={Slide4} class="d-none d-md-block w-100" alt=""></img>
      <img src={Slide44} class="d-block d-md-none w-100" alt=""></img>
      <div class="carousel-caption d-flex align-items-center justify-content-center">
    <div class="d-none d-sm-block">
    <h2 style={{'fontWeight': 'bold'}}>VIDEO CREATOR & EDITOR</h2>
    <p class="m-0" style={{'fontSize': '20px'}}>Creazione e montaggio video</p>
    </div>
    <div class="d-block d-sm-none">
    <h3 style={{'fontWeight': 'bold'}}>VIDEO CREATOR<br></br>& EDITOR</h3>
    <p class="m-0" style={{'fontSize': '15px'}}>Creazione e montaggio video</p>
    </div>
    </div>
    </div>

  </div>

  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>

</div>
)};

export default SlideShow;